module.exports = __webpack_public_path__ + "static/media/MockupLanding.a1717259.png";